document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

	let swiperVerticaltabs = document.querySelectorAll('.vertical-tabs');
    if(swiperVerticaltabs){

        let swiperVerticaltabs = new Swiper('.vertical-tabs__content', {
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
			allowTouchMove: false,
            navigation: {
                nextEl: ".swiper-vertical-tabs-next",
                prevEl: ".swiper-vertical-tabs-prev",
            },
        });       

        let tabs = document.querySelectorAll('.vertical-tabs .js-tab-filter');
        let tabsQuad = document.querySelector('.vertical-tabs');
        let activeTabPin = document.getElementById("tabPin");
        tabs.forEach((tab) => {
            tab.addEventListener('click', function (e) {
                tabs.forEach((noactive) => {
                    noactive.classList.remove('active');
                });
                tab.classList.add('active');
                let tabsQuadPosition = tabsQuad.getBoundingClientRect();
                    tabsQuadPosition = tabsQuadPosition.y;
                let activePinTabPosition = tab.getBoundingClientRect();
                    activePinTabPosition = activePinTabPosition.y;
                let topPos = activePinTabPosition - tabsQuadPosition;
                activeTabPin.setAttribute('style', `top:${topPos}px`);
                console.log(`${topPos}px`);
                
                let tabsIndex = tab.getAttribute("data-index");
                swiperVerticaltabs.slideTo(tabsIndex, 600, false)
            });
            tabs[0].click();
        });
    };

    let swiperReviews = document.querySelectorAll('.reviews');
    if(swiperReviews){

        let swiperReviews = new Swiper('.swiper-reviews', {
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-reviews-next",
                prevEl: ".swiper-reviews-prev",
            },
        });       
        let swiperReviewsV2 = new Swiper('.swiper-reviews-v2', {
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-reviews-next",
                prevEl: ".swiper-reviews-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 25
                },
                1025: {
                    slidesPerView: 3,
                    centeredSlides: true,
                    spaceBetween: 65
                }
            }
        });       
    };

    let swiperReviewsImages = document.querySelectorAll('.reviews-images');
    if(swiperReviewsImages){
        let swiperReviewsImages = new Swiper('.swiper-reviews-images', {
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-reviews-images-next",
                prevEl: ".swiper-reviews-images-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 25
                },
                1025: {
                    slidesPerView: 3,
                    centeredSlides: true,
                    spaceBetween: 65
                }
            }
        });       
    };

    let swiperSlider = document.querySelectorAll('.slider');
    if(swiperSlider){

        let swiperSlider = new Swiper('.slider-swiper', {
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-slider-next",
                prevEl: ".swiper-slider-prev",
            },
        });       
    };

    let swiperEvents = document.querySelectorAll('.events-block');
    if(swiperEvents){

        let swiperEventsImages = new Swiper('.events-block-images-swiper', {
            loop: false,
			allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-event-next",
                prevEl: ".swiper-event-prev",
            },
        });   

        let swiperEvents = new Swiper('.events-block-swiper', {
            loop: false,
			allowTouchMove: false,
            effect: 'fade',
            // speed: 400,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-event-next",
                prevEl: ".swiper-event-prev",
            },
        });   
        
        let prevArrow = document.querySelector('.swiper-event-prev');
        let nextArrow = document.querySelector('.swiper-event-next');
        let contentEvent = document.querySelector('.events-block__content');

        if(prevArrow){
            prevArrow.addEventListener('click', function (e) {
                contentEvent.classList.remove('change');
            });
        }
        if(nextArrow){
            nextArrow.addEventListener('click', function (e) {
                contentEvent.classList.add('change');
            });
        }
    };

    let swiperTimeline = document.querySelectorAll('.timeline-block');
    if(swiperTimeline){
        let swiperTimelineThumbnails = new Swiper('.timeline-block__thumbnails', {
            loop: true,
            slidesPerView: 1,
            autoplay: false,
            navigation: {
                nextEl: ".swiper-timeline-next",
                prevEl: ".swiper-timeline-prev",
            },
            breakpoints: {
                480: {
                  slidesPerView: 4,
                }
              }
        });

        const bulletValues = document.querySelectorAll('.timeline-block .js-dots');
        
        let swiperTimeline = new Swiper('.timeline-block__main', {
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
            autoplay: false,
            navigation: {
                nextEl: ".swiper-timeline-next",
                prevEl: ".swiper-timeline-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    const value = bulletValues[index].getAttribute('data-title');
                    return '<span class="' + className + '">' + value + "</span>";
                },
            },
        });       
    };

    let swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){

        if(document.querySelectorAll('.gallery-bigImage')){
            let swiperGalleryBigImage = new Swiper('.gallery-bigImage', {
                loop: true,
                allowTouchMove: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-gallery-next",
                    prevEl: ".swiper-gallery-prev",
                }
            });   
        }

        if(document.querySelectorAll('.gallery-smallImage')){
            let swiperGallerySmallImage = new Swiper('.gallery-smallImage', {
                loop: true,
                allowTouchMove: true,
                initialSlide: 1,
                slidesPerView: 1.9,
                spaceBetween: 21,
                navigation: {
                    nextEl: ".swiper-gallery-next",
                    prevEl: ".swiper-gallery-prev",
                }
            });   
        }

        if(document.querySelectorAll('.gallery-block-mobile')){
            let swiperGalleryMobile = new Swiper('.gallery-block-mobile', {
                loop: true,
                allowTouchMove: true,
                spaceBetween: 21,
                slidesPerView: 1.2,
                centeredSlides: true,
                navigation: {
                    nextEl: ".swiper-gallery-next",
                    prevEl: ".swiper-gallery-prev",
                }
            }); 
        }
    };

    let presidentialSuitesSwiper = document.querySelectorAll('.presidential-suite-block');
    if(presidentialSuitesSwiper){

        let presidentialSuitesSwiper = new Swiper('.presidential-suite-slides', {
            loop: true,
			allowTouchMove: false,
            slidesPerView: 1.26,
            speed: 600,
            navigation: {
                nextEl: ".swiper-presidential-s-next",
                prevEl: ".swiper-presidential-s-prev",
            }
        });    
    };
    
    let rewardSwiper = document.querySelectorAll('.rewards');
    if(rewardSwiper){

        let rewardSwiper = new Swiper('.rewards-swiper', {
            loop: true,
			allowTouchMove: false,
            slidesPerView: 5,
            spaceBetween: 126,
            navigation: {
                nextEl: ".swiper-reviews-next",
            }
        });    
    };
});